import React from 'react';
import {
	CardButton,
	CardLogo,
	CardLogoWrapper,
	CardTextWrapper,
	CardTitle,
	CardWrapper
} from 'pages/landing/cards/styled';
import bet_bg from 'assets/img/landing/cards/bet_bg.png';
import bww from 'assets/img/landing/cards/bww.svg';
import bet_mgm_logo from 'apps/BWW_PLAY_HUB/assets/img/bet_mgm.png';

import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { getIsBettingAllowed } from 'modules/selectors';
import { useScrollToID } from 'modules/hooks';

const SCardWrapper = styled(CardWrapper)`
  padding-bottom: 0;
  padding-left: 15px;
  justify-content: flex-start;
`;

const SCardTitle = styled(CardTitle)`
  width: 100%;
  font-family: Champion, sans-serif;
  margin-bottom: 4px;
  text-transform: uppercase;
  color: #FFFFFF;
  font-size: 30px;
  letter-spacing: 0;
  line-height: 38px;
  text-align: center;

  p {
	font-size: 38px;
	color: #FEC600;
  }

  @media screen and (max-width: 1000px) {
	font-size: 24px;
	line-height: 32px;

	p {
	  font-size: 30px;
	}
  }
`;

const RegisterText = styled.h3`
  color: #FFFFFF !important;
  font-family: Barlow;
  font-size: 18px !important;
  font-weight: 600;
  letter-spacing: 0 !important;
  line-height: 20px;
  text-align: center;
  margin-top: 6px;
  margin-bottom: 16px !important;

  @media screen and (max-width: 1000px) {
	font-size: 16px !important;
	margin: 8px auto 16px auto !important;
  }
`;


const SCardTextWrapper = styled(CardTextWrapper)`
  @media screen and (max-width: 1000px) {
	> h3 {
	  display: none;
	}
  }
`

const TermsText = styled.p`
  color: #FFFFFF;
  font-family: Eund, sans-serif;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 25px;
  text-align: center;
  margin: 12px 0 22px 0;

  button {
	color: #FFFFFF;
	text-decoration: underline;
	font-weight: 500;
  }

  @media screen and (max-width: 1000px) {
	font-size: 14px;
	margin: 4px 0 8px 0;
  }
`;

const SCardButton = styled(CardButton)`
  @media screen and (max-width: 1000px) {
	font-size: 14px;
  }
`;

const PureButton = styled.button`
  cursor: pointer;
  background: transparent;
  border: none;
  margin: 0;
  padding: 0;
`;

export const BetCard: React.FC = () => {
	const isBettingAllowed = useSelector(getIsBettingAllowed);
	const useScrollTo = useScrollToID('mgm-terms');

	if (!isBettingAllowed) {
		return null;
	}
	return (
		<SCardTextWrapper>
			<h3>&nbsp;</h3>
			<SCardWrapper image={bet_bg}>
				<CardLogoWrapper spbtw={true}>
					<CardLogo src={bww} alt="Upcoming"/>
					<img src={bet_mgm_logo} alt="bet logo"/>
				</CardLogoWrapper>
				<SCardTitle>
					Risk free
					bet up to
					<p>$1,000</p>
				</SCardTitle>
				<RegisterText>+$20 BWW GIFT CARD ON REGISTRATION</RegisterText>
				<SCardButton>
					Exclusive Sports Bet Offer
				</SCardButton>
				<TermsText>
					See <PureButton onClick={useScrollTo}>terms & conditions.</PureButton>
				</TermsText>
			</SCardWrapper>
		</SCardTextWrapper>
	);
}
